import React from 'react';

import cx from 'classnames';

import { StandardSection } from '@commons/standard-section/StandardSection';
import { Button } from '@commons/button/Button';

import * as styles from './about-us-section.module.scss';

export const AboutUsSection = ({
  firstParagraph,
  secondParagraph,
  buttonLabel,
  buttonHref = '#contact',
  imageOnRight,
  imageAltText,
  noImgOnMobile = false,
  spaceOnMobile = false,
  classNames: {
    customImgStyles,
    outerWrapper,
    innerWrapper,
    sectionCustomStyles,
    customStylesSecondParagraph,
    customStylesButton,
  } = {},
}) => {
  return (
    <StandardSection
      className={cx(styles.aboutUsSection, sectionCustomStyles)}
      classNames={{
        outerWrapper: cx(styles.outerWrapper, outerWrapper),
        innerWrapper: cx(styles.innerWrapper, innerWrapper),
      }}
    >
      <div className={styles.container}>
        <div className={styles.aboutUsDescription}>
          <p className={spaceOnMobile && styles.firstParagraphStyles}>{firstParagraph}</p>
          {secondParagraph && <p className={cx(styles.paragraph, customStylesSecondParagraph)}>{secondParagraph}</p>}
          <Button
            className={cx(styles.button, customStylesButton)}
            label={buttonLabel}
            href={buttonHref}
            rel="nofollow"
          />
        </div>
        <div
          className={
            noImgOnMobile
              ? cx(styles.goImageContainer, styles.hideOnMobile, customImgStyles)
              : cx(styles.goImageContainer, customImgStyles)
          }
        >
          <img loading="lazy" src={imageOnRight} alt={imageAltText} />
        </div>
      </div>
    </StandardSection>
  );
};
